import { Text, Button, useToast } from '@chakra-ui/react';
import useToastError from 'hooks/shared/useToastError';
import AppCard from 'presentation/components/shared/card/AppCard';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useRequestQueueForEventMutation } from 'rtkQuery/sharespro/queries/events';

interface Props {
  categoryId: ID;
}

const EventDetailNextEventNotScheduled: FC<Props> = ({ categoryId }) => {
  const { t } = useTranslation();

  const toast = useToast();
  const toastErrorHandler = useToastError();

  const [register, { isLoading }] = useRequestQueueForEventMutation();

  return (
    <>
      <AppCard p="15px">
        <Text mb="10px">{t('nextEventHasNotScheduledYet')}</Text>
        <Button
          onClick={() => {
            register(categoryId)
              .unwrap()
              .then(() => {
                toast({
                  description: t('youRegisteredToWaitingList'),
                  status: 'success',
                  position: 'top-right',
                  isClosable: true,
                });
              })
              .catch(toastErrorHandler);
          }}
          w="full"
        >
          {t('singUpForTheWaitingList')}
        </Button>
      </AppCard>
      <FullScreenLoader isLoading={isLoading} />
    </>
  );
};

export default EventDetailNextEventNotScheduled;
